import React from 'react';
import { TimeStamp } from '../UI/TimeStamp';
import { withLocalize } from 'react-localize-redux';

class ReviewDate extends React.Component {
    render() {
        return (
            <div className="reviewed-date">
                <div>
                    <TimeStamp activityTime={this.props.reviewedDate} /> (
					{this.props.activeLanguage && this.props.reviewedDate.toLocaleDateString(this.props.activeLanguage.code)})
				</div>
            </div>
        );
    }
}

export default withLocalize(ReviewDate)
